
            const data = {"name":"plus-16","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 7a.5.5 0 0 0-.5.5v4h-4a.5.5 0 0 0 0 1h4v4a.5.5 0 0 0 1 0v-4h4a.5.5 0 0 0 0-1h-4v-4A.5.5 0 0 0 12 7Z\" _fill=\"#81889B\"/>","originalColors":[{"type":"fill","color":"#81889B"}],"stopColors":[]}}
        
                    module.exports = data
                    